import CryptoJS from 'crypto-js';
import jwt from 'jsonwebtoken';

import store from './../store/store';
import router from './../router';

const p = '2@%eGH[Qnad?#*P%#axHm1tlSre6Q8';
const w = 'NE8Lw]FLAZlST3*H2rGppQW13,Mp6q';

export function saveListEmpresas(value) {
  localStorage.setItem(
    'listEmpresas',
    CryptoJS.AES.encrypt(JSON.stringify(value), p + w).toString(),
  );

  updateStoreDataEmpresa();
}

export function saveDataLoginDefault(idEmpresa, userToken = null) {
  let decoded = { id_usuario: null };

  if (userToken) {
    decoded = jwt.decode(userToken);
  }

  const dataLoginDefault = {
    idUsuarioInitialLogin: decoded.id_usuario,
    idEmpresaDefault: idEmpresa,
  };

  localStorage.setItem(
    'dataLoginDefault',
    CryptoJS.AES.encrypt(JSON.stringify(dataLoginDefault), p + w).toString(),
  );
}

export function getDataLoginDefault() {
  const dataLoginDefaultCrypto = localStorage.getItem('dataLoginDefault');

  if (dataLoginDefaultCrypto) {
    const bytes = CryptoJS.AES.decrypt(dataLoginDefaultCrypto, p + w);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  return null;
}

export function updateStoreDataEmpresa() {
  // Lista de Empresas
  const listEmpresaCrypto = localStorage.getItem('listEmpresas');

  if (listEmpresaCrypto) {
    const bytes = CryptoJS.AES.decrypt(listEmpresaCrypto, p + w);
    const listEmpresa = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    store.dispatch('updateListEmpresa', listEmpresa);
  }

  // Logo
  const logo = localStorage.getItem('logo');
  store.dispatch('updateLogo', logo);

  // Favicon
  const faviconRaw = localStorage.getItem('favicon');
  const favicon = faviconRaw && faviconRaw !== 'null' ? faviconRaw : null;

  const faviconElement = document.getElementById('favicon');
  if (faviconElement) {
    faviconElement.href = favicon || '/favicon.png';
  }

  store.dispatch('updateFavicon', favicon);

  // Empresa Atual
  const idEmpresa = +(localStorage.getItem('idEmpresa') || 0);
  store.dispatch('updateCurrentEmpresa', idEmpresa);

  // Usuario Logado (inicialmente)
  const dataLoginDefault = getDataLoginDefault();

  if (dataLoginDefault) {
    const { idUsuarioInitialLogin } = dataLoginDefault;

    if (idUsuarioInitialLogin) {
      store.dispatch('updateIdUsuarioInitialLogin', idUsuarioInitialLogin);
    }
  }

  // Nome do Usuário Atual
  const userToken = localStorage.getItem('user-token');
  const decoded = jwt.decode(userToken);
  store.dispatch('updateNomeCurrentUsuario', decoded?.nome);
  store.dispatch('updateProfilePic', decoded?.profilePic);
}

export function observableLocalStorage() {
  window.onstorage = (event) => {
    if (event.key === 'user-token') {
      router.push('/update-login-empresa');
    }
  };
}
